"use client";

import useSWR from "swr";

import SWR_KEYS from "@/constants/swr-keys";
import { ICampaignStatistics } from "@/interfaces/campaign-statistics.interface";
import campaignStatisticsService from "@/services/campaign-statistics.service";
import { PaginatedResponse, RequestPagination, RequestsBaseReturn } from "@/types/requests.types";

export type Return = RequestsBaseReturn<PaginatedResponse<ICampaignStatistics> | null>;

export interface Props extends RequestPagination {
  campaignId: string;
}

type GetStatisticsSwrParams = [string, string, number, number];

const useGetCampaignStatistics = ({ campaignId, pageNumber, pageSize }: Props): Return => {
  const fetcher = useSWR<PaginatedResponse<ICampaignStatistics>, Error, GetStatisticsSwrParams>(
    [SWR_KEYS.getCampaignStatistics, campaignId, pageNumber, pageSize],
    ([, _campaignId, _pageNumber, _pageSize]) =>
      campaignStatisticsService.getStatistics(_campaignId, {
        pageNumber: _pageNumber,
        pageSize: _pageSize,
      }),
    { revalidateOnFocus: false }
  );

  const { data = null, isValidating: isLoading, error } = fetcher;

  return { data, isLoading, error };
};

export default useGetCampaignStatistics;
